import {connect} from "redux-vue";
import Validator from "validatorjs";
import ApiError from "../components/ApiError";
import * as userActions from "../actions/user";
import * as appActions from "../actions/app";
import ModalTemplate, {modalPageDecorator} from "./ModalTemplate";
import ValidatedComponent from "../components/ValidatedComponent";
import LoadingIndicator from "../components/LoadingIndicator";

const PasswordResetModal = modalPageDecorator({
  props: ['user', 'passwordReminder', 'clearErrors'],

  data () {
    return {
      formData: {
        email: ""
      },
      formRules: {
        email: "required|email",
      },
      formErrors: null,
    }
  },

  methods: {

    /**
     *
     * @param event
     * @returns {Promise<void>}
     */
    async onSubmitPress (event) {
      event.preventDefault();
      
      const validation = new Validator(this.formData, this.formRules);

      if (validation.passes()) {
        this.formErrors = null;
        await this.passwordReminder(this.formData.email);

        if (this.user.passwordResetSuccess) {
          this.$router.replace({name: 'PasswordResetResponseModal'});
        }

        if (this.user.passwordResetError) {
          this.formErrors = this.user.passwordResetError.response.data;
        }
      } else {
        this.formErrors = validation.errors.all();
      }
    },
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render (h) {
    return (
      <ModalTemplate>
        <div class="m-2 lg:my-12">
          <div class="bg-white container md:max-w-xl mx-auto rounded shadow-lg relative z-50 overflow-hidden">
            <div class="bg-gray-200 py-5 relative">
              <div onClick={this.dismiss} class="cursor-pointer z-50 absolute left-0 top-0 m-5">
                <i class="mdi mdi-close text-3xl lg:text-4xl leading-none"></i>
              </div>
              <div class="w-11/12 lg:w-8/12 mx-auto">
                <h3 class="font-bold text-2xl mt-10 lg:mt-0 text-center">
                  {this.$t('profile_edit_page.reset_password')}
                </h3>
              </div>
            </div>

            <div class="w-11/12 lg:w-8/12 mx-auto">
              <div class="pt-5 pb-10">
                <form>
                  <div class="mb-4">
                    <label class="block text-gray-700 text-sm mb-2" for="email">
                      {this.$t('email_label')}
                    </label>
                    <ValidatedComponent
                      name="email"
                      errors={this.formErrors}
                      classname="bg-gray-200 text-sm appearance-none border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      renderComponent={classname => (
                        <input class={classname} id="email" type="email" v-model={this.formData.email}/>
                      )}
                    />
                  </div>

                  <ApiError error={this.user.passwordResetError}/>

                  <button class="mb-3 lg:mb-0 px-5 p-2 lg:p-3 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none mx-auto block"
                    type="submit" onClick={this.onSubmitPress} disabled={this.user.passwordReset}>
                    {this.user.passwordReset
                      ? <LoadingIndicator/>
                      : (
                        <fragment>
                          {this.$t('profile_edit_page.send_reset_link')}
                          <i class="mdi mdi-arrow-right ml-5"></i>
                        </fragment>
                      )
                    }
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </ModalTemplate>
    );
  }
});

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

function mapActionToProps(dispatch) {
  return {
    passwordReminder: async (email) => await dispatch(userActions.passwordReminder(email)),
    clearErrors: () => dispatch(appActions.clearErrors()),
  }
}

export default connect(mapStateToProps, mapActionToProps)(PasswordResetModal);
